import BaseSlideout from '../slideout';
import Button, { ButtonType, ButtonState } from '../../button/Button';
import './filtersMobilePanel.scss';

type FilterSlideoutProps = {
  isVisible: boolean;
  onClose: () => void;
  onClear: () => void;
  onApply: () => void;
  children: React.ReactNode;
};

const FilterSlideout = ({
  isVisible,
  onClose,
  onClear,
  onApply,
  children,
}: FilterSlideoutProps) => {
  return (
    <BaseSlideout
      isVisible={isVisible}
      onClose={onClose}
      title="Filters"
      className="filter-slideout"
    >
      <hr className="divider" />
      <div className="slideout-body filter-slideout-body">
        <div className="scrollable-content">{children}</div>
      </div>

      <div className="slideout-footer">
        <hr className="divider" />
        <div className="buttons filter-buttons">
          <Button
            type={ButtonType.TERTIARY}
            state={ButtonState.DEFAULT}
            extraClasses="filter-button"
            onClick={onClear}
            label="Clear Filters"
          ></Button>
          <Button
            type={ButtonType.SECONDARY}
            state={ButtonState.DEFAULT}
            extraClasses="filter-button"
            onClick={onApply}
            label="Apply Filters"
          ></Button>
        </div>
      </div>
    </BaseSlideout>
  );
};

export default FilterSlideout;
